import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-client',
  templateUrl: './main-client.component.html',
  styleUrls: ['./main-client.component.css']
})
export class MainClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
